import { Expose, Transform, Type } from "class-transformer";
import { CreateReturnDeliveryNoteLineDto } from "./create-return-delivery-note-line.dto";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class CreateReturnDeliveryNoteDto {
  @Expose()
  originDeliveryNoteId: string;

  @Expose()
  code: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  date: string;

  @Expose()
  @Type(() => CreateReturnDeliveryNoteLineDto)
  lines: CreateReturnDeliveryNoteLineDto[];
}
